import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const AuthRoute = ({ children }) => {
  const authInfo = useSelector((state) => state.auth);

  if (!authInfo.token || !authInfo.isLoggedIn) {
    return <Navigate to='/login' />
  } else {
    return children;
  }
};

export default AuthRoute;
